function RevealElements()
{
    const observerOptions = {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0.33 // when element is 1/3 in view
    }

    const observer = new IntersectionObserver(function(entries, self) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                requestAnimationFrame(() => {
                    entry.target.classList.add("is-intersecting", "animated");
                    self.unobserve(entry.target);
                });
            }
        });
    }, observerOptions);

    //const observedElements = document.querySelectorAll(':not(.is-intersecting)');
    const observedElements = document.querySelectorAll('.animate');
    if (observedElements.length > 0) {
        //console.log('observedElements', observedElements);
        observedElements.forEach(element => {
            observer.observe(element);
        });
    }
}

export default RevealElements;
